// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1wKJ2","file":"styles_file___RPFb"};